window.Popper = require('popper.js').default;
var MobileDetect = require('mobile-detect');

try {
    require('bootstrap');
}
catch (e) {}

(function ($) {
    
    // CHECK COOKIE
    function getCookie(name) {
        var dc = document.cookie;
        var prefix = name + "=";
        var begin = dc.indexOf("; " + prefix);
        if (begin == -1) {
            begin = dc.indexOf(prefix);
            if (begin != 0) return null;
        }
        else
        {
            begin += 2;
            var end = document.cookie.indexOf(";", begin);
            if (end == -1) {
            end = dc.length;
            }
        }
        // because unescape has been deprecated, replaced with decodeURI
        //return unescape(dc.substring(begin + prefix.length, end));
        return decodeURI(dc.substring(begin + prefix.length, end));
    } 


    

    $(document).ready(function () {
        
        // COOKIE Abfrage
        var myCookie = getCookie("appId");
        if (myCookie == null) {}
        else {
            $('.elementor-location-header').remove();
            $('.elementor-location-footer').remove();
        }


        $('#myTab a').on('click', function (e) {
            e.preventDefault()
        });

        //Color Switch on Scroll
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            var objectSelect = $("#color-switch");

            if(objectSelect.length > 0)
            {
                var objectPosition = objectSelect.offset().top - 400;
                if (scroll > objectPosition) {
                    $(".page").addClass("color-switch");
                } else {
                    $(".page").removeClass("color-switch");
                }
            }
        });


        $('#search-toggle').click(function() {
            $('#search-toggle').toggleClass('od-search__toggle--open');
            $('#od-searchform').toggleClass('od-search__searchform--open');
            $(".elementor-search-form__input").focus();
        });


        $('.elementor-upload-field').on('change', function(e){
            var fileName = e.target.files[0].name;
            $(this).siblings().html(fileName);
        });


        var md = new MobileDetect(window.navigator.userAgent);
        var element = $("[data-elementor-type='wp-post'], [data-elementor-type='wp-page']");

        $('#od-open-menu').click(function() {
            element.addClass('menu-open');
            $('#elementor-popup-modal-44').addClass('od-fade');
        });


        // click außerhalb des menüs
        $(document).on('click', '#elementor-popup-modal-44', function(ev){
            if(ev.target == $('#elementor-popup-modal-44')[0]){
                element.removeClass('menu-open');
                $('#elementor-popup-modal-44').removeClass('od-fade');
                $('#productMenu').removeClass('menu-product-slider--open');
            }
        });

        $(document).on('click', '#elementor-popup-modal-2734', function(ev){
            if(ev.target == $('#elementor-popup-modal-2734')[0]){
                element.removeClass('menu-open');
                $('#elementor-popup-modal-2734').removeClass('od-fade');
                $('#productMenu').removeClass('menu-product-slider--open');
            }
        });


        // esc key
        $(document).on('keydown', function(ev){
            if(ev.which == 27){
                element.removeClass('menu-open');
                $('#elementor-popup-modal-44').removeClass('od-fade');
                $('#productMenu').removeClass('menu-product-slider--open');
            }
        })
        // schließen click
        $(document).on('click', '#od-close-menu', function(){
            element.removeClass('menu-open');
            $('#elementor-popup-modal-44').removeClass('od-fade');
            $('#productMenu').removeClass('menu-product-slider--open');
        });
        // schließen mobile click
        $(document).on('click', '#od-close-menu-2', function(){
            element.removeClass('menu-open');
            $('#elementor-popup-modal-44').removeClass('od-fade');
            $('#productMenu').removeClass('menu-product-slider--open');
        });


        // Product Menu open
        $(document).on('click', '#productMenuBtn', function(){
            $('#productMenu').toggleClass('menu-product-slider--open');
        });
        $(document).on('click', '#close-mobile-product-menu', function(){
            $('#productMenu').removeClass('menu-product-slider--open');
        });

        var whishlistEl = $('.tinvwl-table-manage-list');
        var productInput = $('.elementor-field-group-articleno');

        if(whishlistEl.length && productInput.length){
            $('.wishlist_item').each(function(){
                var ProdName = $(this).find('.product-name a').text();
                productInput.find('input').val(function(index, val){
                    if(val.length === null || val.length === undefined ){ return ProdName; }
                    return val + ' ' + ProdName;
                });
            })
        }


        $( ".btn-gradient" ).each(function() {

            var bgHover = "#0A1D37";
            var radialGradient = "#3D82A6";
            var size = "150%";

            $(this).mousemove(function(e) {

                var x = e.clientX - $(this).offset().left;
                var y = 25;

                $(this).css('background','radial-gradient(circle at '+ x +'px '+ y +'px, '+ radialGradient +','+ bgHover +' '+ size + ')');

            });

            $(this).mouseleave(function() {
                setTimeout(function () {
                    $(this).css('background','');
                }, 300);

            });

        });


        var swiper = new Swiper('.od-img-slider', {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        var swiper = new Swiper('.od-fair-slider', {
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        var swiper = new Swiper('.od-product-slider', {
            slidesPerView: 'auto',
            spaceBetween: 20,
            freeMode: true,
            autoHeight: false,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    });

    /**
     * AJAX LOADING POSTS
     *
     */
    var $posts_holder = $('.od_theme-load-more');

    $posts_holder.each( function() {

        var $_posts_holder = $(this);

        var $loader       = $_posts_holder.next('.od_theme_more-posts-wrap').find('.more_posts'),
            postoptions   = $_posts_holder.find('.posts-grid-settings' ).data( 'postoptions' ),
            post_type     = postoptions.post_type,
            taxonomy      = postoptions.taxonomy,
            ppp           = postoptions.ppp,
            sticky        = postoptions.sticky,
            categories    = postoptions.categories,
            style         = postoptions.style,
            show_thumb    = postoptions.show_thumb,
            img_format    = postoptions.img_format,
            excerpt       = postoptions.excerpt,
            excerpt_limit = postoptions.excerpt_limit,
            meta          = postoptions.meta,
            meta_ordering = postoptions.meta_ordering,
            css_class     = postoptions.css_class,
            grid          = postoptions.grid,
            startoffset   = postoptions.startoffset,
            offset        = $_posts_holder.find('.post').length;

        $loader.on( 'click', load_ajax_posts );

        function load_ajax_posts(e) {

            e.preventDefault();

            if ( !($loader.hasClass('post_loading_loader') || $loader.hasClass('no_more_posts')) ) {

                $.ajax({
                    type: 'POST',
                    dataType: 'html',
                    url: odJsLocalize.ajaxurl,
                    data: {
                        'post_type': post_type,
                        'taxonomy': taxonomy,
                        'ppp': ppp,
                        'sticky': sticky,
                        'categories': categories,
                        'style': style,
                        'show_thumb': show_thumb,
                        'img_format': img_format,
                        'excerpt': excerpt,
                        'excerpt_limit': excerpt_limit,
                        'meta': meta,
                        'meta_ordering': meta_ordering,
                        'css_class': css_class,
                        'grid': grid,
                        'offset': offset + startoffset,
                        'action': 'od_elements_more_post_ajax'
                    },
                    beforeSend : function () {
                        $loader.addClass('post_loading_loader').html(odJsLocalize.loadingposts);
                    },
                    success: function (data) {

                        var $data = $(data);
                        if ($data.length) {
                            var $newElements = $data.css({ opacity: 0 });
                            $_posts_holder.append($newElements);
                            $newElements.animate({ opacity: 1 });
                            $loader.removeClass('post_loading_loader').html(odJsLocalize.loadmore);
                        } else {
                            $loader.removeClass('post_loading_loader').addClass('no_more_posts disabled').html(odJsLocalize.noposts);
                        }
                    },
                    error : function (jqXHR, textStatus, errorThrown) {
                        $loader.html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                    },
                });

            }
            offset += ppp;
            return false;
        }


    }); // end $posts_holder.each

    function hideParents(){

        $('.facetwp-facet').each(function(){
            $(this).closest('div.facet-wrap').removeClass('is-hidden');
        });

        $('.facetwp-facet.is-hidden').each(function(){
            $(this).closest('div.facet-wrap').addClass('is-hidden');
        });
    }

    function addLoader(){
        var loader = '<div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
        $(loader).appendTo('.target');
    }

    $(document).on('facetwp-loaded', function() {
        setTimeout(function(){ hideParents(); },0);

        $('.pa_cw-leistung').each(function(){
            var value = $(this).find('.od-product-attr__value').text();
            var str2=   value.replace(",00", "");
            $(this).find('.od-product-attr__value').text(str2);
        });
    });

    $( document ).on( 'click', '#close-product-popup-md', function( event ) {
        elementorProFrontend.modules.popup.closePopup( {}, event );
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#muegge-customized").offset().top
        }, 2000);
    });

    /**
     *
     * Cookie Management
     * Create, Read & Delete Cookies with good old js
     *
     */

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
        else var expires = "";

        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }


    /**
     *
     * Redirect based on browser language
     * target = en_US
     * from = en-CA, en-US, es-MX
     *
     */


    $(document).ready(function(){
        //do_language_redirect();
    });

    function do_language_redirect(){
        var language = navigator.language || navigator.browserLanguage; // browserLanguage for ie
        //console.log('language', language);

        var langCookie = readCookie('od_language');
        //console.log('od_language', langCookie);

        if(!langCookie){
            //console.log('langCookie is empty');

            if (language.toLowerCase().indexOf("en") >= 0){
                if(language === 'en-CA' || language === 'en-US' || language === 'es-MX'){
                    window.location.replace("https://muegge.de/en_US/");
                }else{
                    window.location.replace("https://muegge.de/en/");
                }
            }else if(language.toLowerCase().indexOf("zh") >= 0){
                window.location.replace("https://muegge.de/zh-hans/");
            }else{
                window.location.replace("https://muegge.de/");
            }
            createCookie('od_language', language, 1 );
        }
    }


}(jQuery));
